import { Dialog } from '@mui/material';

const DialogContainer = ({
  open,
  onClose,
  children,
  size = 'medium',
  maxWidth = false,
  minHeight = '50vh',
  ...props
}) => {
  const getSizeStyles = (size) => {
    const sizeMap = {
      small: {
        width: { xs: '90%', sm: '80%', md: '60%' },
        maxWidth: '600px',
      },
      medium: {
        width: { xs: '95%', sm: '90%', md: '80%' },
        maxWidth: '1200px',
      },
      large: {
        width: { xs: '95%', sm: '95%', md: '90%' },
        maxWidth: '1600px',
      },
      fullWidth: {
        width: '95%',
        maxWidth: '100%',
      },
    };

    return sizeMap[size] || sizeMap.medium;
  };

  const sizeStyles = getSizeStyles(size);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      sx={{
        '& .MuiDialog-paper': {
          ...sizeStyles,
          margin: { xs: 1, sm: '32px' },
          width: { xs: '90%', sm: sizeStyles.width.sm || sizeStyles.width },
          maxHeight: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 64px)' },
          borderRadius: 1,
          minHeight: minHeight,
        },
      }}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default DialogContainer;
